import PropTypes from 'prop-types';
import { memo } from 'react';
import { projectFormatter } from './projectFormatter.js';

export let ProgressBar = ({ project }) => {
    const percentFunded = Math.round(100 * projectFormatter.fractionFunded(project.costToComplete,
        project.totalPrice, project.matchingFund ? project.matchingFund.amount : 0));

    return (
        <div className="progress-bar-holder js-progress-bar-holder">
            <span className="progress" style={{ width: percentFunded + '%' }}></span>
        </div>
    );
};
ProgressBar.propTypes = {
    project: PropTypes.shape({
        costToComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        totalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        matchingFund: PropTypes.object.isRequired,
    }),
};

ProgressBar = memo(ProgressBar);
